import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Button, Divider, Icon, Form } from 'antd';

import moment from 'moment';

import SelectedFilters from './SelectedFilters';

// Filter fields
import ServiceTypes from '../../../../common/FilterSections/ServiceTypes';
import Passengers from '../../../../common/FilterSections/Passengers';
import Drivers from '../../../../common/FilterSections/Drivers';
import Arrival from '../../../../common/FilterSections/Arrival';
import Cost from '../../../../common/FilterSections/Cost';
import Executors from '../../../../common/FilterSections/Executors';
import WeekDays from '../../../../common/FilterSections/WeekDays';
import RouteLength from '../../../../common/FilterSections/RouteLength';
import Vehicle from '../../../../common/FilterSections/Vehicle';
/*
import Responsible from './fields/Responsible';
import Watcher from './fields/Watcher';
import Regions from './fields/Regions';
import StatusPayment from './fields/StatusPayment';
import PaymentMethods from './fields/PaymentMethods';
import ReservationDate from './fields/ReservationDate';
import OfferEndDate from './fields/OfferEndDate';
import CustomerAcceptance from './fields/CustomerAcceptance';
import Carriers from './fields/CustomerAcceptance';
*/

class Filters extends React.PureComponent {
  getFilter = (name, form) => {
    switch (name) {
      case 'ord_servtype':
        return <ServiceTypes key={name} form={form} />;
      case 'ord_passqnt':
        return <Passengers key={name} form={form} />;
      case 'ord_drv':
        return <Drivers key={name} form={form} />;
      case 'ord_arrper':
        return <Arrival key={name} form={form} />;
      case 'ord_price':
        return <Cost key={name} form={form} />;
      case 'ord_exec':
        return <Executors key={name} form={form} />; // todo
      case 'ord_weekdays':
        return <WeekDays key={name} form={form} />;
      case 'ord_rtlng':
        return <RouteLength key={name} form={form} />;
      case 'ord_vehicle':
        return <Vehicle key={name} form={form} />;
      default:
        return null;
      /*
        <Regions form={form} />
        <StatusPayment form={form} />
        <PaymentMethods form={form} />
        <ReservationDate form={form} />
        <OfferEndDate form={form} />
        <CustomerAcceptance form={form} />
        <Carriers form={form} />
      */
    }
  };
  render() {
    const {
      showFilterAll, // не рефакторил
      showDrawer, // не рефакторил
      toggleAllFilter, // не рефакторил
      // работа с фильтрами
      form,
      settingsFilters,
      toggleVisibleMap,
      visibleMap,
      resetFilters,
    } = this.props;

    let filters = settingsFilters ? settingsFilters : [];
    let otherFilters = [];
    if (filters.length > 6 && filters.length !== 7) {
      otherFilters = filters.slice(6);
      filters = filters.slice(0, 6);
    }

    return (
      <div className="b-table-filters b-table-filters_filters">
        <div className="b-table-filters__wrap-col">
          {filters.length > 0 && (
            <div className="b-table-filters__col3">
              <SelectedFilters resetFilters={resetFilters} />
            </div>
          )}
          <div className="b-table-filters__col2">
            <Button
              className="orders__button-custom"
              type="link"
              onClick={toggleVisibleMap}
            >
              {visibleMap ? 'Закрыть карту' : 'Заказы на карте'}
              <Icon style={{ fontSize: '18px' }} type="environment" />
            </Button>
          </div>
          {filters.length === 0 && (
            <div className="b-table-filters__col2">
              <Button
                type="link"
                className="withIcon withIcon_setting right"
                onClick={showDrawer}
              >
                Настроить столбцы
                <Icon type="setting" />
              </Button>
            </div>
          )}
        </div>
        {filters && filters.map(key => this.getFilter(key, form))}
        {showFilterAll &&
          otherFilters &&
          otherFilters.map(key => this.getFilter(key, form))}
        {!showFilterAll && (
          <Fragment>
            {filters.length !== 0 && (
              <div
                className="b-table-filters__col"
                style={filters.length === 4 ? { paddingTop: 0 } : null}
              >
                <Button
                  type="link"
                  className="withIcon withIcon_setting right"
                  onClick={showDrawer}
                >
                  Настроить столбцы
                  <Icon type="setting" />
                </Button>
              </div>
            )}
            {filters.length > 4 && otherFilters.length !== 0 && (
              <div className="b-table-filters__col">
                <Button
                  onClick={toggleAllFilter}
                  className="orders__button-custom"
                  type="link"
                >
                  Показать еще фильтры
                  <Icon style={{ fontSize: '12px' }} type="down" />
                </Button>
              </div>
            )}
          </Fragment>
        )}
        {showFilterAll && (
          <Fragment>
            <Divider style={{ height: 1, backgroundColor: '#d9d9d9' }} />
            <div className="b-table-filters__wrap-col">
              <div className="b-table-filters__col4">
                <Button
                  type="link"
                  className="withIcon withIcon_setting right"
                  onClick={showDrawer}
                >
                  Настроить столбцы
                  <Icon type="setting" />
                </Button>
              </div>
              <div className="b-table-filters__col4">
                <Button
                  onClick={toggleAllFilter}
                  className="orders__button-custom"
                  type="link"
                >
                  Скрыть фильтры
                  <Icon style={{ fontSize: '12px' }} type="up" />
                </Button>
              </div>
            </div>
          </Fragment>
        )}
      </div>
    );
  }
}

class FiltersData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getValueByFieldName(name, val) {
    if (name.includes('Date')) {
      return (val && moment(val)) || null;
    } else {
      return val;
    }
  }

  saveFormRef = formRef => {
    if (formRef && formRef.props && formRef.props.form) {
      this.formRef = formRef.props.form;
    } else {
      this.formRef = null;
    }
    // this.props.setForm(this.props.name, this.formRef);
  };

  render() {
    return (
      <FormOrderFilter
        {...this.props}
        wrappedComponentRef={this.saveFormRef}
        getValueByFieldName={this.getValueByFieldName}
      />
    );
  }
}

const FormOrderFilter = Form.create({
  name: 'orderFilters',
  onFieldsChange(props, changedFields) {
    props.handleFiltersChange(props.form.getFieldsValue());
  },
  mapPropsToFields(props) {
    let obj = {};
    props.data &&
      Object.keys(props.data).forEach(name => {
        obj[name] = Form.createFormField({
          value: props.getValueByFieldName(name, props.data[name]),
        });
      });
    return obj;
  },
  onValuesChange(props, values) {},
})(Filters);

export default connect(state => ({
  data: state.Executorship.Orders.filters.fields,
}))(FiltersData);
